module.exports = __webpack_public_path__ + "static/img/Bigger_Logo_01.25285a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Bigger_Logo_01.png
// module id = gGlG
// module chunks = 1